import React, { Component } from 'react';
import { Table, Popconfirm, Button, Input, message,Select } from 'antd';
import { ExportModal, UpdateCustomerApprove } from './UpdateCustomerApprove';
import SearchRetrieve from '../../common/SearchRetrieve';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const { Option } = Select;

class Filter extends Component {
    state = {
        searchParams: {
            workStatus: 'WORKING',
        },
    }

    search = () => {
        const {
            searchParams,
        } = this.state;
        this.props.search({ ...searchParams });
    }

    export = () => {
        this.props.export();
    }

    enterSearch = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }
    
    handleInputChange = (e, field) => {
        const { searchParams } = this.state;
        searchParams[field] = e.target.value;
        this.setState({ searchParams });
    }

    handleSelectChange = (value, field) => {
        const { searchParams } = this.state;
        searchParams[field] = value;
        this.setState({ searchParams });
    }

    handleChange = (type, value, options, isLoading) => {
        const { searchParams } = this.state;
        const { key, label } = value || {};
        const obj = {};
        if (type === 'investigation') {
            searchParams.investigationId = key;
            searchParams.investigationName = label;
            obj.investigationOptions = options;
        } else if (type === 'sponsor') {
            searchParams.investigationSponsorId = key;
            searchParams.investigationSponsorName = label;
            obj.sponsorOptions = options;
        }
        this.setState({
            ...obj,
            searchParams,
        });
    }

    render() {
        const {
            searchParams: {
                employeeCode,
                userCompellation,
                workStatus,
                investigationId,
                investigationName,
                investigationSponsorId,
                investigationSponsorName,
            },
            investigationOptions = [],
            sponsorOptions = [],
        } = this.state;
        const investigationValue = investigationId ? { key: String(investigationId), label: investigationName } : {};
        const sponsorValue = investigationSponsorName ? { key: String(investigationSponsorId), label: investigationSponsorName } : {};
        return (
            <div className="filter-bar">
                <div className="form-item">
                    <label htmlFor="" className="ui-label">工号</label>
                    <Input
                        placeholder="请输入"
                        value={employeeCode}
                        onChange={e => this.handleInputChange(e, 'employeeCode')}
                        onKeyPress={this.enterSearch}
                    />
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">姓名</label>
                    <Input
                        placeholder="请输入"
                        value={userCompellation}
                        onChange={e => this.handleInputChange(e, 'userCompellation')}
                        onKeyPress={this.enterSearch}
                    />
                </div>
                <div className="form-item">
                    <label className="ui-label">项目简称</label>
                    <SearchRetrieve
                        type="investigation"
                        keyword="investigationName"
                        style={{ width: 162 }}
                        placeholder="输入名称检索"
                        value={investigationValue}
                        data={investigationOptions}
                        params={{ limit: 20 }}
                        url={API_URL.investigation.queryInvestigationByName}
                        config={{ id: 'investigationId', name: 'investigationName' }}
                        onChange={this.handleChange}
                    />
                </div>
                <div className="form-item">
                    <label className="ui-label">申办方</label>
                    <SearchRetrieve
                        type="sponsor"
                        keyword='customerCompanyName'
                        style={{ width: 172 }}
                        placeholder="输入名称检索"
                        value={sponsorValue}
                        data={sponsorOptions}
                        params={{ limit: 20, natureName: '申办方' }}
                        url={API_URL.investigation.queryCustomerCompanyByName}
                        config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                        onChange={this.handleChange}
                    />
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">状态</label>
                    <Select
                        onChange={value => this.handleSelectChange(value, 'workStatus')}
                        placeholder="请选择"
                        value={workStatus}
                        style={{width:90}}
                        allowClear={true}
                    >
                        <Option value="WORKING">在职</Option>
                        <Option value="LEFT">离职</Option>
                    </Select>
                </div>
                <div className="form-item">
                    <Button type="primary" onClick={this.export}>导出</Button>
                    <Button type="primary" onClick={this.search}>搜索</Button>
                </div>
            </div>
        );
    }
}

class Approve extends Component {
    state = {
        data: [],
        sortParams: {},
        searchParams: {
            workStatus: 'WORKING'
        },
        pagination: {
            pageSize: 10,
            current: 1,
        },
        loading: false,
        expandedRowKeys: [],
        subList: {},
        role: {},
    }

    componentDidMount() {
        const { curRole } = sessionStorage;
        const role = {
            isVP: curRole == 'VP',
            isFIN: curRole == 'FIN',
            isHRRC: curRole == 'HRRC',
        };
        this.setState({ role }, () => {
            this.loadData();
        })
    }
    
    search = (params) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams: params,
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { searchParams } = this.state;
        this.showExportModal(searchParams);
    }

    loadData = () => {
        const { sortParams, searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.queryDirectSubordinateList,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas = [], totalCount = 0 } = res;
                pagination.total = totalCount;

                const expandedRowKeys = [];
                const values = Object.values(searchParams);
                if (values.some(i => !!i)) {
                    datas.forEach(i => expandedRowKeys.push(i.userId));
                }

                this.setState({
                    pagination,
                    data: datas,
                    loading: false,
                    expandedRowKeys,
                }, () => {
                    expandedRowKeys.forEach(i => this.loadSubData(i));
                });
            }
        };
        $.sendRequest(options);
    }

    loadSubData = (userId) => {
        const { searchParams } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.queryUserAwardList,
            data: {
                ...searchParams,
                userId,
            },
            dataType: 'json',
            doneResult: res => {
                const { subList } = this.state;
                subList[userId] = res.list;
                this.setState({
                    subList,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    subDelete = (row) => {
        const { userId, userAwardId } = row;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.delUserAward,
            data: { userAwardId },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.loadSubData(userId);
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }


    handleTableChange = (pagination, filters, sorter) => {
        const { sortParams } = this.state;
        sortParams.sort = sorter.field ;
        sortParams.direction = sorter.order ? sorter.order == 'descend' ? 'DESC' : 'ASC' : '';
        this.setState({
            subList: {},
            pagination,
            sortParams,
        }, () => {
            this.loadData();
        });
    }

    getDateRender = text => text ? text.slice(0, 10) : ''

    getColumns = () => {
        const { role: { isVP, isFIN, isHRRC } } = this.state;
        const columns = [{
            title: '工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            width: 80,
            sorter: true,
        }, {
            title: '姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 80,
        }, {
            title: '职位/级别',
            dataIndex: 'positionName',
            key: 'positionName',
        }, {
            title: '手机号码',
            dataIndex: 'userMobile',
            key: 'userMobile',
        },{
            title: '邮箱',
            dataIndex: 'email',
            key: 'email',
            width: 180,
        }, {
            title: '工作城市',
            dataIndex: 'workCity',
            key: 'workCity',
        }];
        if (!(isVP || isFIN || isHRRC)) {
            columns.push({
                title: '操作',
                dataIndex: 'operate',
                key: 'operate',
                width: 100,
                render: (text, record) => {
                    return <a onClick={() => this.updateCustomerApprove(record)}>添加认可记录</a>
                }
            })
        }
        return columns;
    }

    getDataSource = () => {
        const { data, pagination: { current, pageSize } } = this.state;
        const dataSource = data.map((item, index) => {
            const { workStatus } = item;
            return {
                index: (current - 1) * pageSize + index + 1,
                ...item,
                workStatus: workStatus ? (workStatus === 'WORKING' ? '在职' : "离职") : '',
            };
        });
        return dataSource;
    }

    onExpand = (expanded, record) => {
        const { expandedRowKeys } = this.state;
        if (expandedRowKeys.length == 0) {
            expandedRowKeys.push(record.userId);
        } else {
            if (expanded) {
                expandedRowKeys.push(record.userId);
            } else {
                expandedRowKeys.map((item, index) => {
                    if (item == record.userId) {
                        expandedRowKeys.splice(index, 1);
                    };
                });
            }
        }
        this.setState({ expandedRowKeys });
        if (expanded) {
            this.loadSubData(record.userId);
        }
    }

    downLoadFile = (e, fileMetaId) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({ fileMetaId }, null, url);
    }

    expandedRowRender = (record) => {
        const { userId } = record;
        const { role: { isVP, isFIN, isHRRC }, subList } = this.state;
        const subData = subList[userId] || [];

        const getDateRender = text => text ? text.slice(0, 10) : '';
        const getColumns = () => {
            const columns = [{
                title: '序号',
                dataIndex: 'index',
                key: 'index',
                width: 60,
            }, {
                title: '时间',
                dataIndex: 'awardTime',
                key: 'awardTime',
                width: 90,
                render: getDateRender,
            }, {
                title: '项目简称',
                dataIndex: 'investigationName',
                key: 'investigationName',
                width: 120,
            }, {
                title: '申办方',
                dataIndex: 'sponsorName',
                key: 'sponsorName',
                width: 100,
            }, {
                title: '获得认可说明',
                dataIndex: 'awardComments',
                key: 'awardComments',
                width: 160,
            }, {
                title: '认可方式',
                dataIndex: 'awardType',
                key: 'awardType',
                width: 80,
                render: text => text ? text == 'PENNANT' ? '锦旗' : text == 'TROPHY' ? '奖杯' : '荣誉证书' : '',
            }, {
                title: '附件',
                dataIndex: 'fileList',
                key: 'fileList',
                width: 185,
                render: text => text ? text.map(i => <a key={i.fileMetaId} onClick={e => this.downLoadFile(e, i.fileMetaId)}>{i.fileName}<br /></a>) : '',
            }];
            if (!(isVP || isFIN || isHRRC)) {
                columns.push({
                    title: '操作',
                    dataIndex: 'operate',
                    key: 'operate',
                    width: 80,
                    render: (text, row) => {
                        return (
                            <span>
                                <a onClick={() => this.updateCustomerApprove(record, row)}>修改</a>
                                <span className="ant-divider" />
                                <Popconfirm title="确定要删除吗?" onConfirm={() => this.subDelete(row)}>
                                    <a>删除</a>
                                </Popconfirm>
                            </span>
                        )
                    }
                });
            }
            return columns;
        }
    
        const getDataSource = () => {
            const dataSource = [];
    
            if (subData && subData.length > 0) {
                subData.map((item, index) => {
                    dataSource.push({
                        index: index + 1,
                        ...item,
                    });
                });
            }
            return dataSource;
        };

        return (
            <Table
                rowKey={record => record.index}
                columns={getColumns()}
                dataSource={getDataSource()}
                pagination={false}
                scroll={{ x: 875, y: 300 }}
            />
        );
    }

    updateCustomerApprove = (parentParams, params) => {
        this.updateCustomerApproveRef.show(parentParams, params);
    }

    showExportModal = (params) => {
        this.exportModalRef.show(params);
    }

    render() {
        const { loading, pagination, expandedRowKeys } = this.state;
        return (
            <div>
                <Filter
                    search={this.search}
                    export={this.export}
                />
                <Table
                    loading={loading}
                    scroll={{ x: 955 }}
                    pagination={pagination}
                    columns={this.getColumns()}
                    dataSource={this.getDataSource()}
                    rowKey={record => record.userId}
                    onChange={this.handleTableChange}
                    onExpand={this.onExpand}
                    expandedRowKeys={expandedRowKeys}
                    expandedRowRender={this.expandedRowRender}
                />
                <UpdateCustomerApprove ref={el => this.updateCustomerApproveRef = el} loadData ={this.loadSubData} />
                <ExportModal ref={el => this.exportModalRef = el} />
            </div>
        );
    }
}

export default Approve;


// WEBPACK FOOTER //
// ./src/components/user/userInfo/Approve.js